<template>
    <el-form
        :model="form"
        :rules="rules"
        ref="registerPersonal"
        label-width="95px"
        label-position="right"
        size="medium"
        status-icon>
        <!-- 登录名 -->
        <el-form-item 
            :label="$t('message.register.username')"
            prop="username">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="register-presonal-popover">
                    <li>{{$t('message.register.unameNorm1')}}</li>
                    <li>{{$t('message.register.unameNorm2')}}</li>
                    <li>{{$t('message.register.unameNorm3')}}</li>
                    <li>{{$t('message.register.unameNorm4')}}</li>
                </ul>
                <el-input 
                    v-model="form.username"
                    slot="reference"
                    clearable>
                </el-input>
            </el-popover>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item 
            :label="$t('message.register.pwd')"
            prop="password">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="register-presonal-popover">
                    <li>{{$t('message.register.pwdNorm1')}}</li>
                    <li>{{$t('message.register.pwdNorm2')}}</li>
                    <li>{{$t('message.register.pwdNorm3')}}</li>
                </ul>
                <el-input 
                    type="password"
                    v-model="form.password"
                    slot="reference"
                    clearable>
                </el-input>
            </el-popover>
        </el-form-item>
        <!-- 密碼確認 -->
        <el-form-item 
            :label="$t('message.register.cpwd')"
            prop="cpwd">
            <el-input 
                type="password" 
                v-model="form.cpwd"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 電子郵箱 -->
        <el-form-item 
            :label="$t('message.register.email')"
            prop="email">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="register-presonal-email-tips">
                    <li>{{$t("public.emailTips")}}</li>
                </ul>
                <el-input 
                    type="textarea"
                    v-model="form.email"
                    slot="reference"
                    autosize>
                </el-input>
            </el-popover>
        </el-form-item>
        <!-- 聯絡人姓名 -->
        <el-form-item 
            :label="$t('message.register.consignee')"
            prop="consignee">
            <el-input 
                v-model="form.consignee"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 聯繫電話 -->
        <el-form-item 
            :label="$t('message.register.mobile')"
            prop="mobile">
            <el-input 
                v-model="form.mobile"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 地址 -->
        <el-form-item 
            :label="$t('message.register.address2')"
            prop="address">
            <el-input 
                v-model="form.address"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 验证码 -->
        <el-form-item 
            :label="$t('message.register.code')"
            prop="code">
            <el-input
                v-model="form.code"
                class="register_presonal_code_input">
                <template #append>
                    <a href="javascript:;"
                        class="identify_code"
                        @click="refreshCode" >
                        <s-identify 
                            :identifyCode="identifyCode"
                            canvas-id="presonal-code"
                            :contentHeight="35">
                        </s-identify>
                    </a>
                </template>
            </el-input>
        </el-form-item>
        <!-- 我已阅读并同意 -->
        <el-form-item>
            <el-checkbox v-model="form.isSure">{{$t("message.register.forSure")}}</el-checkbox>
            <el-button
                type="text"
                @click="handleAgreement">
                《{{$t('message.register.agreement')}}》
            </el-button>
        </el-form-item>
        <!-- 提交 -->
        <el-form-item>
            <el-button
                type="primary"
                @click="submitForm">
                <span>{{$t("public.submitBtn")}}</span>
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { uname, pwd, cpwd, code, email } from "@/utils/validate";

export default {
    data() {
        let validateUname = (rule, value, callback) => { // 用户名验证
            uname(this, rule, value, callback);
        },
        validatepwd = (rule, value, callback) => { // 密码验证
            pwd(this, "registerPersonal", rule, value, callback);
        },
        validatepwd2 = (rule, value, callback) => { // 密码重复验证
            cpwd(this, rule, value, callback);
        },
		validateEmail = (rule, value, callback) => {
		    email(this, true, value, callback);
		},
        validateCode = (rule, value, callback) => { // 验证码验证
            code(this, rule, value, callback);
        }
        // validateEmail = (rule, value, callback) => {
        //     email(this, true, value, callback);
        // };
        return {
            // 验证码组
            identifyCodes: "1234567890abcdefghijklmnopqrstuvwxyz",
            // 验证码
            identifyCode: "",
            // 表单绑定数据
            form:{
                username:"",
                password:"",
                cpwd:"",
                email:"",
                consignee:"",
                mobile:"",
                address:"",
                code:"",
                isSure: false
            },
            // 规则
            rules: {
                username:[
                    { required: true, validator: validateUname, trigger: [ 'blur', 'change' ] }
                ],
                password: [
                    { required: true, validator: validatepwd, trigger: 'blur' }
                ],
                cpwd: [
                    { required: true, validator: validatepwd2, trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: validateEmail, trigger: ['blur', 'change'] }
                ],
                consignee:[
                    { required: true, message: this.$t("message.register.errconsignee"), trigger: 'blur' },
                ],
                mobile:[
                    { required: true, message: this.$t("message.register.errmobile"), trigger: 'blur' },
                ],
                address:[
                    { required: true, message: this.$t("message.register.erraddress"), trigger: 'blur' },
                ],
                code: [
                    { required: true, validator: validateCode, trigger: 'blur'}
                ]
            },
        }
    },
    components: {
        SIdentify: () => import("@/components/identify")
    },
    methods: {
        ...mapMutations([
            "handleDialog"
        ]),
        ...mapActions([
            "sendRegister",
            "handleValidateUname",
            "getColumnContent"
        ]),
        // 验证码函数
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        // 更换验证码函数
        refreshCode() {
            // 清空输入框
            this.form.code = "";
            // 清空生成验证码
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        // 生成验证码函数
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        handleAgreement(){ // 打开协议条款
            this.getColumnContent(6);
            this.handleDialog(true);
        },
        // 
        // 
        // 提交注册信息
        submitForm() {
            this.$refs.registerPersonal.validate((valid) => {
                this.refreshCode();
                if (valid) {
                    // 向服务器发起请求
                    this.sendRegister(this.form).then((res)=>{
                        if(res.isRegister){
                            this.$alert(this.$t("message.register.succregister"),{
                                type:'success',
                                dangerouslyUseHTMLString:true,
                                center:true,
                                confirmButtonText: this.$t("public.goLogin"),
                                callback:action=>{
                                    this.$router.replace('/login')
                                }
                            })
                            // 清空数据
                            this.form = {
                                username:"",
                                password:"",
                                cpwd:"",
                                email:"",
                                consignee:"",
                                mobile:"",
                                address:"",
                                code:"",
                                isSure: false,
                            }
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
    },
    created() {
        // 生成验证码
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
    },
}
</script>

<style scoped>
/* 注册提示弹出框 */
.register-presonal-popover{
    list-style-type: circle;
    padding-left: 20px;
}
.register_presonal_code_input>>>.el-input-group__append{
    padding: 0
}
/* 验证码 */
.identify_code{
    display: inline-block;
    vertical-align: middle;
    width: 115px;
    height: 35px;
    text-align: center;
}
.register-presonal-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
</style>
